import Tooltip from './Tooltip';

export default function ModeCard({ selected, onClick, icon, label, description, current, disabled, disabledReason }) {
	return (
		<button
			type='button'
			onClick={disabled ? undefined : onClick}
			aria-disabled={disabled}
			className={`text-left border rounded-lg p-4 ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${
				selected ? 'border-black' : 'border-gray-200 hover:bg-gray-50'
			}`}
		>
			<div className='flex items-center gap-2 mb-1'>
				{icon}
				<span className='font-medium text-sm'>{label}</span>
				{current && <span className='text-xs text-gray-400'>Current</span>}
				{disabled && disabledReason && <Tooltip content={disabledReason} />}
			</div>
			<p className='text-xs text-gray-500'>{description}</p>
		</button>
	);
}
